import React from 'react';
import { LazyImage } from '../images/LazyImage';
import { SimpleUserView } from '../../../../mainv3/types/users';
import DefaultProfile from './default_profile.png';
import './userProfileCell.module.scss';
import classNames from 'classnames';

type Props = {
    user: SimpleUserView;
    size?: 'm' | 'l';
};

export const UserProfileCell = ({ user, size = 'm' }: Props) => {
    return (
        <div styleName="user-profile-cell">
            <LazyImage
                src={user.profile_url || DefaultProfile}
                offset={100}
                styleName={classNames('profile-image', size)}
            />
            <span styleName={classNames('name', size)}>{user.name}</span>
        </div>
    );
};
